export default __webpack_public_path__ + "static/media/Persona2.ddca5649.png";